import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-day-picker/lib/style.css';
import ReactDatePicker from 'react-day-picker';
import styled, { css } from 'styled-components';
import { TitleSection, LegendSection, RectangleWhite } from './styled';
import { stringToBoolean } from '../../utilities/conversionUtility';

// If highlightColor is transparent then apply default color for highlighted days.
const StyledDatePicker = styled(ReactDatePicker)`
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled) {
    background-color: ${props => css`
      ${props.highlightColor !== 'transparent' ? props.highlightColor : '#4A90E2'} !important 
    `};
  }

  .DayPicker-Day--disabled {
    pointer-events: none;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected) {
    position: relative !important;
  }

  .DayPicker-Day--selected.DayPicker-Day--start:not(.DayPicker-Day--disabled) {
    &:after {
      content: "";
      position: absolute;
      top: 3px;
      left: 3px;
      width: 10px;
      height: 10px;
      background-color: #fff;
    }
  }

  .DayPicker-Day.DayPicker-Day--selected.DayPicker-Day--outside {
    color: white;
  }

  .DayPicker-Day.DayPicker-Day--selected.DayPicker-Day--start.DayPicker-Day--outside {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      bottom: 3px;
      right: 3px;
      width: 10px;
      height: 10px;
      background-color: #fff;
    }
  }

  .DayPicker-Day.DayPicker-Day--selected.DayPicker-Day--end.DayPicker-Day--outside {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      bottom: 3px;
      right: 3px;
      width: 10px;
      height: 10px;
      background-color: #fff;
    }
  }

  .DayPicker-Day--selected.DayPicker-Day--end:not(.DayPicker-Day--disabled) {
    &:after {
      content: "";
      position: absolute;
      bottom: 3px;
      right: 3px;
      width: 10px;
      height: 10px;
      background-color: #fff;
    }
  }

  .DayPicker-Day.DayPicker-Day--blackoutOverlap:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    color: #d1d1d1;
  }

  .DayPicker-Day.DayPicker-Day--blackoutOverlap:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled):hover {
    color: #d1d1d1;
    background-color: transparent !important;
    &:before {
      content: "";
      position: absolute;
      top:-6px;
      left:50%;
      transform: translateX(-50%);
      border-width: 4px 6px 0 6px;
      border-style: solid;
      border-color: rgba(0,0,0,0.7) transparent transparent     transparent;
      z-index: 100;
    }
    &:after {
      content: '${props => (props.tooltips ? props.tooltips.blackoutsOverlap : 'Blacked out')}';
      position: absolute;
      left:50%;
      top:-6px;
      transform: translateX(-50%)   translateY(-100%);
      background: rgba(0,0,0,0.7);
      text-align: center;
      color: #fff;
      padding:4px 2px;
      font-size: 12px;
      min-width: 80px;
      border-radius: 5px;
      pointer-events: none;
    }
  }

  .DayPicker-Day.DayPicker-Day--hoverHighlight:not(.DayPicker-Day--bookedDates):not(.DayPicker-Day--disabled):not(.DayPicker-Day--blackoutOverlap) {
    background-color: ${props => css`
      ${props.hoverColor ? props.hoverColor.backgroundColor : '#2c81cc'}
    `} !important;
    color: white;
  }

  .DayPicker-Day.DayPicker-Day--bookedDates:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    color: #d1d1d1;
  }

  .DayPicker-Day.DayPicker-Day--bookedDates:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled):hover {
    background-color: transparent !important;
    &:before {
      content: "";
      position: absolute;
      top:-6px;
      left:50%;
      transform: translateX(-50%);
      border-width: 4px 6px 0 6px;
      border-style: solid;
      border-color: rgba(0,0,0,0.7) transparent transparent     transparent;
      z-index: 100;
    }
    &:after {
      content: '${props => (props.tooltips ? props.tooltips.bookedDates : 'Cannot be chosen as start date')}';
      position: absolute;
      left:50%;
      top:-6px;
      transform: translateX(-50%)   translateY(-100%);
      background: rgba(0,0,0,0.7);
      text-align: center;
      color: #fff;
      padding:4px 2px;
      font-size: 12px;
      min-width: 80px;
      border-radius: 5px;
      pointer-events: none;
    }
  }

  .DayPicker-Day.DayPicker-Day--nonAvailable:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled) {
    color: #d1d1d1;
  }

  .DayPicker-Day.DayPicker-Day--nonAvailable:not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled):hover {
    color: #d1d1d1;
    background-color: transparent !important;
    &:before {
      content: "";
      position: absolute;
      top:-6px;
      left:50%;
      transform: translateX(-50%);
      border-width: 4px 6px 0 6px;
      border-style: solid;
      border-color: rgba(0,0,0,0.7) transparent transparent     transparent;
      z-index: 100;
    }
    &:after {
      content: '${props => (props.tooltips ? props.tooltips.nonAvailable : 'Shop closed')}';
      position: absolute;
      left:50%;
      top:-6px;
      transform: translateX(-50%)   translateY(-100%);
      background: rgba(0,0,0,0.7);
      text-align: center;
      color: #fff;
      padding:4px 2px;
      font-size: 12px;
      min-width: 80px;
      border-radius: 5px;
      pointer-events: none;
    }
  }

  .DayPicker-NavButton.DayPicker-NavButton--prev {
    pointer-events: ${props => (props.isDisableCalendar ? 'none' : 'unset')};
    opacity: ${props => (props.isDisableCalendar ? 0.5 : 1)};
  }

  .DayPicker-NavButton.DayPicker-NavButton--next {
    pointer-events: ${props => (props.isDisableCalendar ? 'none' : 'unset')};
    opacity: ${props => (props.isDisableCalendar ? 0.5 : 1)};
  }

`;

export default class RentalDatePicker extends Component {
  onMonthChange = (value) => {
    const { onMonthChange } = this.props;
    onMonthChange(value);
  };

  onDayClick = (day, modifiers = {}) => {
    const { onDayClick } = this.props;
    onDayClick(day, modifiers);
  };

 handleDayMouseEnter = (day) => {
   const { handleDayMouseEnter } = this.props;
   handleDayMouseEnter(day);
 }

 handleDayMouseLeave = () => {
   const { handleDayMouseLeave } = this.props;
   handleDayMouseLeave();
 }

 render() {
   const {
     setting,
     from,
     enteredTo,
     styled: widgetType,
     renderDay,
     disabledDays,
     modifiers,
     isDisableCalendar,
   } = this.props;
   const selectedDays = [from, { from, to: enteredTo }];
   const disabledDaysArr = [];
   // disable days before today.
   disabledDaysArr.push({ before: disabledDays.beforeToday });
   if (isDisableCalendar) {
     disabledDaysArr.push({
       after: new Date(Date.now()),
     });
     disabledDaysArr.push(new Date(Date.now()));
   }
   return (
      <div>
        {setting.headline && (
          <TitleSection backgroundColor={setting.header_background_color}>
            <span>{setting.headline}</span>
          </TitleSection>
        )}
        <StyledDatePicker
          fixedWeeks
          className="Range"
          renderDay={renderDay}
          modifiers={modifiers}
          selectedDays={selectedDays}
          isDisableCalendar={isDisableCalendar}
          onDayClick={this.onDayClick}
          disabledDays={disabledDaysArr}
          onMonthChange={this.onMonthChange}
          hoverColor={widgetType.buttonStyle}
          highlightColor={setting.highlight_color}
          onDayMouseEnter={this.handleDayMouseEnter}
          onDayMouseLeave={this.handleDayMouseLeave}
          tooltips={{
            nonAvailable: 'Closed',
            bookedDates: 'Booked out',
            blackoutsOverlap: 'Booked out',
          }}
        />
        {stringToBoolean(setting.display_legend) === true && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', maxWidth: '50%' }}>
              <LegendSection style={{ minWidth: '50px' }} backgroundColor={setting.legend_background_color}>
                <RectangleWhite
                  style={{
                    top: 1,
                    left: 1,
                  }}
                />
              </LegendSection>

              <div style={{
                display: 'flex',
                padding: '0 10px',
                flexDirection: 'column',
                wordBreak: 'break-word',
              }}>
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: setting.booking_start_text }} />
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', maxWidth: '50%' }}>
              <div
                style={{
                  display: 'flex',
                  padding: '0 10px',
                  alignItems: 'flex-end',
                  flexDirection: 'column',
                  wordBreak: 'break-word',
                }}
              >
                {/* eslint-disable-next-line react/no-danger */}
                <div dangerouslySetInnerHTML={{ __html: setting.booking_end_text }} />
              </div>
              <LegendSection style={{ minWidth: '50px' }} backgroundColor={setting.legend_background_color}>
                <RectangleWhite
                  style={{
                    right: 1,
                    bottom: 1,
                  }}
                />
              </LegendSection>
            </div>
          </div>
        )}
      </div>
   );
 }
}

RentalDatePicker.propTypes = {
  setting: PropTypes.object,
  isDisableCalendar: PropTypes.bool,
};
